import React from 'react';
import { Spinner } from 'react-bootstrap';
import { ServicesContext } from '~/services';

export interface RemoveColumnPresetProps {
    onDismiss: () => void;
    colPreset: string;
}

export function RemoveColumnPreset({ onDismiss, colPreset }: RemoveColumnPresetProps) {
    const servicesContext = React.useContext(ServicesContext);
    const [deleting, setDeleting] = React.useState(false);

    async function handleSave() {
        setDeleting(true);
        await servicesContext.user.removeSavedSearchData('column_presets', colPreset);
        setDeleting(false);
        onDismiss();
    }

    return (
        <div className="row text-center">
            <div className="col">
                <div className="d-inline-block me-3 mb-2">
                    Are you sure? This action cannot be undone.
                </div>
                <div className="d-inline-block">
                    <button className="btn btn-secondary me-2" type="button" onClick={onDismiss}>
                        Cancel
                    </button>
                    <button
                        className="btn btn-danger"
                        disabled={deleting}
                        type="button"
                        onClick={handleSave}
                    >
                        {deleting && (
                            <Spinner
                                animation="border"
                                variant="light"
                                size="sm"
                                role="status"
                                className="me-1"
                            />
                        )}
                        Yes, Delete
                    </button>
                </div>
            </div>
        </div>
    );
}
